// src/features/preorders/components/ActionsMenu.tsx

import {
  Box,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import i18n from "i18next";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

interface ActionsMenuProps {
  onValidate: () => void;
  onRefuse: () => void;
  onConsult: () => void;
  status: string;
}

const ActionsMenu: React.FC<ActionsMenuProps> = ({ onValidate, onRefuse, onConsult, status }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isPending = status === "Pending";

  return (
    <Box>
      <Button
        aria-controls="actions-menu"
        aria-haspopup="true"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownOutlinedIcon />}
        sx={{ backgroundColor: "#F1F1F1", color: "#000000", width: "auto" }}
      >
        {i18n.t("preOrders.buttons.actions")}{" "}
      </Button>
      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            onConsult();
          }}
        >
          <ListItemIcon>
            <FeedOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={i18n.t("preOrders.buttons.consult")}
            sx={{ fontFamily: "Poppins" }}
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            onValidate();
          }}
          disabled={!isPending}
        >
          <ListItemIcon>
            <CheckOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={i18n.t("preOrders.buttons.validate")}
            sx={{ fontFamily: "Poppins" }}
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            onRefuse();
          }}
          disabled={!isPending}
        >
          <ListItemIcon>
            <CloseOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={i18n.t("preOrders.buttons.refuse")}
            sx={{ fontFamily: "Poppins" }}
          />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ActionsMenu;
